import { CSS_SELECTOR_SEPARATOR, FOLLOW_UP_PARENT_ELEMENTS_CHECK } from '../const/common';
import { log } from './debug';
import { getPercentOfView } from './dom';
import { getFollowUpVariableFromElement } from './followUp';
import { triggerPathAndQuery } from './matchElementPathAndDomain';

export const prepareJourneyOrFollowUpTriggers = (doc, triggerFollowUpEvent, triggerJourneyEvent, isFollowUpCampaign = true) => {
  let triggered = false;
  const trigger = (triggerElement, extraVariables) => {
    triggered = true;

    let variables = {};
    if (doc.triggerAutoVariables && doc.triggerAutoVariables.length) {
      doc.triggerAutoVariables.forEach((variable) => {
        const variableName = variable.variable;

        if (variableName === 'scrollPercentage') {
          variables[variableName] = window.pageYOffset;
          return;
        }

        if (variable.selectorType === 'js') {
          try {
            variables[variableName] = eval(variable.selector);
            return;
          } catch (ignored) { }
        }

        if (variable.selector && variable.selector.indexOf('javascript:') === 0) {
          const javascriptCode = variable.selector.substr('javascript:'.length);
          try {
            variables[variableName] = eval(javascriptCode);
            return;
          } catch (ignored) { }
        }

        let element;
        variable.selector.split(CSS_SELECTOR_SEPARATOR).forEach((selector) => {
          if (element) {
            return;
          }

          // go up to 10 parent elements, if no match use document
          let tryElement = triggerElement;
          try {
            for (let i = 0; i < FOLLOW_UP_PARENT_ELEMENTS_CHECK; i += 1) {
              element = tryElement.querySelector(selector.trim());
              if (element) {
                break;
              }
              tryElement = tryElement.parentNode;
              if (!tryElement) {
                break;
              }
            }

            if (!element) {
              element = document.querySelector(selector.trim());
            }
          } catch (error) {
            log.debug('followUp variable error', error?.message);
          }
        });

        if (element) {
          variables[variableName] = getFollowUpVariableFromElement(element, variableName);
        }
      });
    }

    if (typeof extraVariables === 'object') {
      variables = Object.assign(variables, extraVariables);
    }

    const triggerEventName = `trigger${doc.triggerType[0].substr(0, 1).toUpperCase() + doc.triggerType.substr(1)}`;

    if (isFollowUpCampaign) {
      triggerFollowUpEvent(doc._id, triggerEventName, variables);
    } else {
      triggerJourneyEvent(doc._id, triggerEventName, variables, doc.type);
    }
  };

  if (doc.triggerType === 'articleBounce' && window.location.hash.indexOf('#cleverPushScroll') !== 0) {
    const setupBounce = () => {
      window.addEventListener('unload', () => {
        const articleElement = document.querySelector(doc.triggerArticleSelector || 'article');
        if (articleElement) {
          const scrollPercent = getPercentOfView(articleElement);
          if (scrollPercent >= (doc.triggerArticleMinScroll || 0) && scrollPercent <= (doc.triggerArticleMaxScroll || 80)) {
            trigger(document);
          }
        }
      });
    };

    if (doc.triggerFunction) {
      let success = false;
      try {
        success = !!eval(doc.triggerFunction);
      } catch (err) {
        log.debug(err);
      }
      if (success) {
        setupBounce();
      }
    } else {
      setupBounce();
    }
  }

  if (doc.triggerType === 'selector' && doc.triggerSelector) {
    const setupSelector = () => {
      const triggerElements = document.querySelectorAll(doc.triggerSelector);
      for (let triggerElementIndex = 0; triggerElementIndex < triggerElements.length; triggerElementIndex += 1) {
        const triggerElement = triggerElements[triggerElementIndex];
        if (triggerElement) {
          triggerElement.addEventListener('click', () => {
            trigger(triggerElement.parentNode);
          }, true);
        }
      }
    };

    if (doc.triggerFunction) {
      let success = false;
      try {
        success = !!eval(doc.triggerFunction);
      } catch (err) {
        log.debug(err);
      }
      if (success) {
        setupSelector();
      }
    } else {
      setupSelector();
    }
  }

  if (doc.triggerType === 'function' && doc.triggerFunction) {
    let result;
    try {
      result = eval(doc.triggerFunction);
    } catch (err) {
      log.debug(err);
    }
    if (typeof result === 'object' && result?.then) {
      try {
        result.then((variables) => {
          trigger(document, variables);
        }).catch((err) => {
          log.debug(err);
        });
      } catch (err) {
        log.debug(err);
      }
    } else if (result) {
      trigger(document);
    }
  } else if (doc.triggerType === 'path' && doc.triggerPath && triggerPathAndQuery(doc.triggerPath)) {
    trigger(document);
  }

  if (doc.triggerType === 'exitIntent') {
    import('ouibounce').then(({ default: ouibounce }) => {
      ouibounce(null, {
        aggressive: true,
        callback: () => {
          if (doc.triggerFunction) {
            let result;
            try {
              result = eval(doc.triggerFunction);
            } catch (err) {
              log.debug(err);
            }
            if (!result) {
              return;
            }
          }

          if (doc.triggerPath && !triggerPathAndQuery(doc.triggerPath)) {
            return;
          }

          trigger(document);
        }
      });
    });
  }

  if (['productAvailability', 'productPriceReduction'].includes(doc.triggerType) && doc.triggerFunction) {
    let productId;
    try {
      productId = eval(doc.triggerFunction);
    } catch (err) {
      log.debug(err);
    }
    // allow delayed triggers with promises
    if (typeof productId === 'object' && productId?.then) {
      try {
        productId.then((id) => {
          if (id && typeof id !== 'object') {
            trigger(document, { id });
          }
        }).catch((err) => {
          log.debug(err);
        });
      } catch (err) {
        log.debug(err);
      }
    } else if (productId) {
      trigger(document, { id: productId });
    }
  }

  if ((doc.cancelType === 'selector' || doc.cancelType === 'function') && doc.cancelSelector) {
    const triggerElements = document.querySelectorAll(doc.cancelSelector);
    for (let triggerElementIndex = 0; triggerElementIndex < triggerElements.length; triggerElementIndex += 1) {
      const triggerElement = triggerElements[triggerElementIndex];
      if (triggerElement) {
        // eslint-disable-next-line no-loop-func
        triggerElement.addEventListener('click', () => {
          if (isFollowUpCampaign) {
            triggerFollowUpEvent(doc._id, doc.cancelType === 'function' ? 'cancelFunction' : 'cancelSelector', doc.type);
          } else {
            triggerJourneyEvent(doc._id, doc.cancelType === 'function' ? 'cancelFunction' : 'cancelSelector', doc.type);
          }
        }, true);
      }
    }
  }

  if (!triggered && doc.cancelType === 'function' && doc.cancelFunction) {
    let result;
    try {
      result = eval(doc.cancelFunction);
    } catch (err) {
      log.debug(err);
    }
    if (typeof result === 'object' && result?.then) {
      try {
        result.then(() => {
          if (isFollowUpCampaign) {
            triggerFollowUpEvent(doc._id, 'cancelFunction');
          } else {
            triggerJourneyEvent(doc._id, 'cancelFunction', doc.type);
          }
        });
      } catch (err) {
        log.debug(err);
      }
    } else if (result) {
      if (isFollowUpCampaign) {
        triggerFollowUpEvent(doc._id, 'cancelFunction');
      } else {
        triggerJourneyEvent(doc._id, 'cancelFunction', doc.type);
      }
    }
  } else if (!triggered && doc.cancelType === 'path' && doc.cancelPath && triggerPathAndQuery(doc.cancelPath)) {
    if (isFollowUpCampaign) {
      triggerFollowUpEvent(doc._id, 'cancelPath');
    } else {
      triggerJourneyEvent(doc._id, 'cancelPath', doc.type);
    }
  }
};
